import { mapState } from "vuex";
import Vue from "vue";
import moment from "moment";

Vue.mixin({
  data() {
    return {
      hiddenTodos: false,
    };
  },
  methods: {
    scrollToInvalidInput(inputs) {
      const inputError = inputs.find((input) => input.hasError);
      if (inputError) {
        const el = inputError.$el;
        const y =
          el.getBoundingClientRect().top +
          window.scrollY -
          document.querySelector(".app-bar")?.offsetHeight -
          20;

        window.scroll({
          top: y,
          behavior: "smooth",
        });
      }
    },
    async $confirm({ title, description }) {
      return new Promise((resolve) => {
        this.$root.$emit("confirmDialog", {
          title,
          description,
          callback: (value) => {
            resolve(value);
          },
        });
      });
    },
    $alert(message, type = "success") {
      this.$root.$emit("alert", {
        message,
        type,
      });
    },
    isProduction() {
      return window.location.hostname == "profile.community.ideasunited.com";
    },
  },
  computed: {
    ...mapState({
      authToken: (state) => state.auth.token,
      currentUser: (state) => state.user.current,
      datasources: (state) => state.datasources.data,
      currentProject: (state) => state.project.current,
    }),
    activeTheme() {
      return (
        this.currentProject?.active_theme
      );
    },
    currentTimezone() {
      return moment.tz.guess(true);
    },
    $size() {
      return this.$vuetify.breakpoint.name;
    },
  },
});
